import { RouteItem } from '@eastcoal/router/types/route'

import {
  DICT_CREATE_PAGE_PATH,
  DICT_DETAIL_PAGE_PATH,
  DICT_EDIT_PAGE_PATH,
  DICT_LIST_PAGE_PATH
} from './constants/path'
import { DICT_ACTION_UUID, DICT_LIST_PAGE_UUID } from './constants/uuid'

export const dictRoute: RouteItem = {
  title: '字典管理',
  uuid: DICT_LIST_PAGE_UUID,
  hideChildrenInMenu: true,
  children: [
    {
      title: '字典列表',
      path: DICT_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '新增字典',
      path: DICT_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑字典',
      path: DICT_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '字典详情',
      path: DICT_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    },
    {
      title: '删除字典',
      uuid: DICT_ACTION_UUID
    }
  ]
}
